import { IconButton } from "@base-ui";
import { NavWrapper, SubNavButton, MainSiteSubNavButton, ExternalSubNavButton } from "./header.styles";
import HeaderSubNav from "./HeaderSubNav";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderNav(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen,
    adminAccess = _ref.adminAccess,
    closeMenu = _ref.closeMenu,
    measuresCategories = _ref.measuresCategories,
    reportCategories = _ref.reportCategories;
  return /*#__PURE__*/_jsxs(NavWrapper, {
    id: "site-navigation",
    className: open ? "open" : "",
    zIndex: "102",
    children: [/*#__PURE__*/_jsx(IconButton, {
      id: "close-main-menu",
      icon: "cross",
      m: "0 0 0 auto",
      label: "St\xE4ng menyn",
      className: "no-border",
      onClick: closeMenu
    }), /*#__PURE__*/_jsxs("ul", {
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(MainSiteSubNavButton, {
          href: "/",
          width: "100%",
          m: "10px 0 0",
          children: "V\xC5RDEN I SIFFROR"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: adminAccess && /*#__PURE__*/_jsx(SubNavButton, {
          to: "/admin",
          variant: "navigation",
          children: "Admin"
        })
      }), /*#__PURE__*/_jsx(HeaderSubNav, {
        id: "measures-select",
        label: "Indikatorer",
        closeMenu: closeMenu,
        entries: measuresCategories,
        open: open,
        setOpen: setOpen
      }), /*#__PURE__*/_jsx(HeaderSubNav, {
        id: "reports-select",
        label: "Rapporter",
        closeMenu: closeMenu,
        open: open,
        setOpen: setOpen,
        entries: reportCategories
      }), adminAccess && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(ExternalSubNavButton, {
          href: "http://insikt.vardenisiffror.se/",
          variant: "navigation",
          children: "Analysst\xF6d"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SubNavButton, {
          to: "/mina-enhetslistor",
          variant: "navigation",
          children: "Mina enhetslistor"
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SubNavButton, {
          to: "/dataexport",
          variant: "navigation",
          children: "Dataexport"
        })
      }), adminAccess && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(SubNavButton, {
          to: "/logout",
          variant: "navigation",
          children: "Logga ut"
        })
      })]
    })]
  });
}